import { reactive } from "vue"

// Confirmation before a destructive action (delete, remove, cancel...), shown in the single
// DestructiveConfirmModal instance that App.vue mounts to <body>.
//
//   const confirmed = await confirm_destructive({
//     title: "Delete bucket",
//     message: "This bucket and all objects in it will be permanently deleted.",
//     subject: bucket.name,
//     type_to_confirm: bucket.name,
//     confirm_button: "Delete Bucket",
//   })
//   if(!confirmed) return

export interface DestructiveActionOptions {
  // Dialog heading, e.g. "Delete bucket"
  title: string
  // What happens, as plain text (no HTML)
  message: string
  // Name of the affected item, shown highlighted under the message
  subject?: string
  // Further consequences, listed under the message, e.g. "Any client using this key will lose access."
  consequences?: string[]
  // When set, the confirm button is only enabled once exactly this text is typed (or pasted) into a text box.
  // Deletes pass the subject's name here, so nothing gets deleted by an accidental click.
  type_to_confirm?: string
  // Label of the confirm button, e.g. "Delete Bucket"
  confirm_button: string
  // Label of the cancel button
  cancel_button?: string
}

interface DialogState {
  open: boolean
  options: DestructiveActionOptions | null
  resolve: ((confirmed: boolean) => void) | null
}

export const destructive_dialog = reactive<DialogState>({
  open: false,
  options: null,
  resolve: null,
})

// Resolves to true when the user confirmed, false when they cancelled or dismissed the dialog
export function confirm_destructive(options: DestructiveActionOptions): Promise<boolean> {
  // A dialog that is still open counts as cancelled
  close_destructive_dialog(false)
  return new Promise<boolean>(resolve => {
    destructive_dialog.options = options
    destructive_dialog.resolve = resolve
    destructive_dialog.open = true
  })
}

export function close_destructive_dialog(confirmed: boolean) {
  const resolve = destructive_dialog.resolve
  destructive_dialog.open = false
  destructive_dialog.resolve = null
  resolve?.(confirmed)
}
